import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "f-w-700" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "f-w-700" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "row h-100" }
const _hoisted_12 = { class: "col h-100" }
const _hoisted_13 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = {
  class: "form-check-label",
  for: "preset"
}
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "f-w-700" }
const _hoisted_19 = ["placeholder"]

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useCondimentStore } from '@/store/management/condimentsStore';
import type { Condiment } from '@/store/management/condimentsStore';

import { useI18n } from 'vue-i18n'
import { condimentsBasicLanguage } from '@/core/locales/condiments-language';


export default /*@__PURE__*/_defineComponent({
  __name: 'condimentsBasic',
  setup(__props) {

const { t } = useI18n({
  messages: condimentsBasicLanguage
})

const condimentsAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/condimentsPage/condimentsAltLangModal.vue'))

const condimentStore = useCondimentStore()

onMounted(() => {
    if (tempActiveCondiment.value?.id) {
        compState.id = tempActiveCondiment.value.id
        compState.name = tempActiveCondiment.value.name
        compState.price = tempActiveCondiment.value.price
        compState.preset = tempActiveCondiment.value.preset
        compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
    }
})

const compState = reactive({
    id: '',
    name: '',
    price: 0,
    preset: false,
    altLangText: ''
})

const activeCondiment = computed(() => {
    return condimentStore.getActiveCondiment
})

const tempActiveCondiment = computed(() => {
    return condimentStore.getTempActiveCondiment
})

const activeCondimentId = computed(() => {
    return condimentStore.getActiveCondimentId
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
}

watch(activeCondimentId, (newVal) => {
    if (newVal) {
        const productGroup = activeCondiment.value
        compState.id = productGroup.id
        compState.name = productGroup.name
        compState.price = productGroup.price
        compState.preset = productGroup.preset
        compState.altLangText = altDisplayText(tempActiveCondiment.value.altDisplayLang)
    }
}, { immediate: true })

watch(compState, (newVal) => {
    condimentStore.setTempActiveCondiment({
        ...tempActiveCondiment.value,
        id: newVal.id,
        name: newVal.name,
        price: newVal.price,
        preset: newVal.preset,
    } as Condiment)
}, { deep: true });

const priceIncrement = () => {
    compState.price++
}

const priceDecrement = () => {
    if (compState.price > 0) {
        compState.price--
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_4, _toDisplayString(_unref(t)('CondimentName')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.name) = $event)),
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('Name'),
            maxlength: "32"
          }, null, 8, _hoisted_5), [
            [_vModelText, compState.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("label", null, [
          _createElementVNode("h6", _hoisted_7, _toDisplayString(_unref(t)('Price')), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: _unref(t)('Threshold'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.price) = $event))
          }, null, 8, _hoisted_9), [
            [_vModelText, compState.price]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: priceDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: priceIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "preset",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.preset) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.preset]
                ]),
                _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(t)('Preset')), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", null, [
            _createElementVNode("h6", _hoisted_18, _toDisplayString(_unref(t)('AlternativeDisplayLanguage')), 1)
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            placeholder: _unref(t)('AlternativeDisplayLanguage'),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.altLangText) = $event)),
            maxlength: "32",
            readonly: "",
            "data-bs-toggle": "modal",
            "data-original-title": "test",
            "data-bs-target": "#alt-lang-modal"
          }, null, 8, _hoisted_19), [
            [_vModelText, compState.altLangText]
          ])
        ])
      ])
    ]),
    _createVNode(_unref(condimentsAltLangModal), { onOnSave: onEditAltLang })
  ], 64))
}
}

})